// dependencies
import React from 'react';
import { FaRegSadTear } from 'react-icons/fa';

const SomethingWrong = () => {
   return (
      <>
         <h1 className="failed">Something went wrong!</h1>
         <img src="img/404.svg" alt="NOT FOUND" />
         <h2 style={{ letterSpacing: '1px' }}>
            There was an API problem! <FaRegSadTear />
         </h2>
      </>
   );
};

export default SomethingWrong;
